export default "__VITE_ASSET__LE$BvkZx__"